module.exports = __webpack_public_path__ + "static/img/puting_4.123fcbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/puting_4.png
// module id = o8Qx
// module chunks = 1